import { css } from 'linaria';

export namespace Styles {
  export const layout = css`
    position: relative;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    background-color: #ffffff;
  `;

  export const closeButton = css`
    position: absolute;
    top: 32px;
    right: 32px;

    background-color: var(--control-invert);
  `;

  export const thumbsContainer = css`
    position: relative;
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: 184px;
    padding-top: 16px;
    padding-left: 16px;
  `;

  export const thumbsContainerMedium = css`
    flex-basis: 144px;
  `;

  export const thumbsScroller = css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    box-sizing: border-box;
    width: 84px;
    height: 100%;
    overflow-x: hidden;

    overflow-y: auto;

    scroll-behavior: smooth;
  `;

  export const thumb = css`
    position: relative;
    display: block;
    flex-grow: 0;
    flex-shrink: 0;
    box-sizing: border-box;
    width: 64px;
    height: 64px;
    padding: 6px;

    margin: 0;
    margin-bottom: 8px;
    background: none;
    border: 2px solid;
    border-color: transparent;
    border-radius: 4px;
    outline: none;
    -webkit-appearance: none;
    -moz-appearance: none;

    &:hover {
      border-color: var(--hover-minor);
    }
  `;

  export const thumbActive = css`
    border-color: var(--control-primary);
  `;

  export const thumbImg = css`
    display: block;
    box-sizing: border-box;
    width: 48px;
    height: 48px;
  `;

  export const toPrevPhotoContainer = css`
    position: absolute;
    top: 0;
    right: -24px;
    bottom: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 48px;
  `;

  export const photoViewport = css`
    flex-grow: 1;
    flex-shrink: 0;
    flex-basis: 800px;
    box-sizing: border-box;

    padding-top: 16px;
    padding-bottom: 16px;
  `;

  export const photoViewportMedium = css`
    flex-basis: 624px;
  `;

  export const rightContainer = css`
    position: relative;
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: 120px;
  `;

  export const rightContainerMedium = css`
    flex-basis: 80px;
  `;

  export const toNextPhotoContainer = css`
    position: absolute;
    top: 0;
    left: -24px;
    bottom: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 48px;
  `;

  export const contentPicture = css`
    display: block;
    width: 100%;
    height: 100%;
    object-fit: scale-down;
  `;
}
